import { ChipProps } from "@mui/material";
import { AppState } from "../types/appIntegration.types";

export const APP_STATUS_CONFIG: Record<
  AppState,
  {
    label: string;
    color: ChipProps["color"];
    variant?: ChipProps["variant"];
  }
> = {
  installed: {
    label: "Installed",
    color: "success",
    variant: "outlined",
  },
  not_installed: {
    label: "Available",
    color: "info",
    variant: "outlined",
  },
  pending: {
    label: "Pending",
    color: "warning",
    variant: "outlined",
  },
  error: {
    label: "Error",
    color: "error",
    variant: "outlined",
  },
  outdated: {
    label: "Outdated",
    color: "warning",
    variant: "outlined",
  },
  inactive: {
    label: "Inactive",
    color: "default",
    variant: "outlined",
  },
};
